const DEAD_ZONE = 8;

const DEFAULT_THRESHOLD = 80;


export {
    DEAD_ZONE,
    DEFAULT_THRESHOLD,
}
